import type { ThemeId } from "@/lib/api";

/**
 * The query for /export/pdf. `look` is sent only when this export asks for a
 * look other than the document's (the document keeps its theme), and
 * `printSafe` only when it is on.
 */
export function pdfExportParams(opts: {
  engine: string;
  look: ThemeId;
  documentLook: ThemeId;
  printSafe: boolean;
  locked: boolean;
  /** The accessible PDF (tagged, for screen readers), 1 Nov 2026: the API picks its engine. */
  accessible?: boolean;
}): URLSearchParams {
  const params = new URLSearchParams({ engine: opts.engine });
  if (!opts.locked && opts.look !== opts.documentLook) params.set("look", opts.look);
  if (opts.printSafe) params.set("printSafe", "true");
  if (opts.accessible) params.set("accessible", "true");
  return params;
}
